module.exports = __webpack_public_path__ + "img/stock2.6f044815.png";